import { LeadResponseStatus } from 'modules/leads';

type ResultModalContent = {
  title: string;
  text: string[];
  button: string;
};

type ResultModalContentStructure = {
  [key in LeadResponseStatus]: ResultModalContent & { defaultValue: ResultModalContent };
};

export const RESULT_MODAL_CONTENT: ResultModalContentStructure = {
  Created: {
    title: 'result-modal.created.title',
    text: ['result-modal.created.text1', 'result-modal.created.text2'],
    button: 'result-modal.created.button',
    defaultValue: {
      title: 'Благодарим за заявку!',
      text: ['С Вами свяжется менеджер', 'для уточнения деталей'],
      button: 'ОК',
    },
  },
  Conflict: {
    title: 'result-modal.conflict.title',
    text: ['result-modal.conflict.text1', 'result-modal.conflict.text2'],
    button: 'result-modal.conflict.button',
    defaultValue: {
      title: 'Мы уже получили вашу заявку',
      text: ['Скоро мы с вами свяжемся.', 'Пожалуйста, дождитесь ответа.'],
      button: 'Хорошо',
    },
  },
};
